import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, ToastController, ViewController} from 'ionic-angular';
import {Storage} from "@ionic/storage";
import {ServiceProvider} from "../../providers/service/service";
import {DatePipe} from "@angular/common";


@Component({
    selector: 'page-add-predata-call-reminder',
    templateUrl: 'add-predata-call-reminder.html',
})
export class AddPredataCallReminderPage {

    Comment: any;
    date: any;
    time: any;
    today: any;

    PreData: any;

    FPredataId: any;
    CallStatusId: any;
    ReminderDate: any;
    ReminderTime: any;
    CreatedByName: any;
    CreatedBy: any;

    FUserId: any;
    userName: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,public loadingCtrl:LoadingController,public datepipe: DatePipe,
                public storage: Storage, public service: ServiceProvider, public toastCtrl: ToastController, public viewCtrl: ViewController) {
        Promise.all([this.storage.get('LoginData'), this.storage.get('UserData')]).then(values => {

            this.FUserId = values[0]['FUserId'];
            this.userName = values[1]['Name'];


            this.PreData = navParams.get('predata');
            if (this.PreData) {
                this.FPredataId = this.PreData.FPredataId;
                this.CallStatusId = this.PreData.CallStatusId;
                console.log("this.PreData->",this.PreData);
            }


        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AddPredataCallReminderPage');
    }

    dismiss() {
        this.viewCtrl.dismiss(0);
    }

    add_reminder() {
        if (this.date == null || this.date == '' || this.date == undefined) {
            this.service.showToast("Select Date");
        }
        else {

            const jsonobj = {
                FPredataId: this.FPredataId,
                ReminderDate: this.datepipe.transform(this.date, 'yyyy-MM-dd'),
                ReminderTime: this.time,
                CreatedByName: this.userName,
                CreatedBy: this.FUserId,
                Comment:this.Comment
            }

            console.log("jsonobj->",jsonobj);

            let loading = this.loadingCtrl.create({
                content: 'Please wait...'
            });
            loading.present();

            this.service.httppostcall('app_web_service/add_call_reminder_predata?', jsonobj).subscribe(data1 => {
                console.log(data1);
                if (data1['response'] == "success") {
                    loading.dismiss();
                    this.viewCtrl.dismiss(data1['message']);
                } else {
                    loading.dismiss();
                }
            }, (error2 => {
                loading.dismiss();
            }))

        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/add-predata-call-reminder/add-predata-call-reminder.ts